var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn main_btn ",class:[
    _vm.page_name + '_page',
    {
      selected_page: this.selectedPage === this.page_name,
      'text-body3': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-body5': _vm.$mq === 'm',
      'text-body6': _vm.$mq === 's'
    }
  ],style:({ color: _vm.currentColor }),attrs:{"to":("/" + _vm.page_name)},nativeOn:{"click":function($event){return _vm.selectPage(_vm.page_name)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }